var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClearSky(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9995 6L63.4874 9.61797C65.7701 11.9866 69.3488 12.5536 72.2525 11.0072L76.6878 8.64352L78.8871 13.1623C80.3254 16.12 83.5556 17.767 86.7955 17.1902L91.7439 16.3139L92.4385 21.2917C92.8926 24.5513 95.4551 27.1114 98.7147 27.5679L103.692 28.2625L102.816 33.2108C102.242 36.4508 103.886 39.6785 106.844 41.1193L111.363 43.3186L108.999 47.7539C107.45 50.6576 108.017 54.2363 110.388 56.519L113.999 59.9995L110.381 63.4874C108.012 65.7701 107.445 69.3488 108.992 72.2525L111.356 76.6878L106.837 78.8871C103.879 80.3254 102.232 83.5556 102.809 86.7955L103.685 91.7439L98.7073 92.4385C95.4477 92.8926 92.8877 95.4551 92.4311 98.7147L91.7365 103.692L86.7882 102.816C83.5482 102.242 80.3205 103.886 78.8797 106.844L76.6805 111.363L72.2451 108.999C69.3414 107.45 65.7627 108.017 63.48 110.388L59.9995 113.999L56.5116 110.381C54.2289 108.012 50.6502 107.445 47.7465 108.992L43.3112 111.356L41.112 106.837C39.6736 103.879 36.4435 102.232 33.2035 102.809L28.2552 103.685L27.5605 98.7073C27.1064 95.4477 24.5439 92.8877 21.2843 92.4311L16.3065 91.7365L17.1828 86.7882C17.7572 83.5482 16.1126 80.3205 13.1549 78.8797L8.63616 76.6805L10.9999 72.2451C12.5487 69.3414 11.9817 65.7627 9.6106 63.48L6 59.9995L9.61797 56.5116C11.9866 54.2289 12.5536 50.6502 11.0072 47.7465L8.64352 43.3112L13.1623 41.112C16.12 39.6736 17.767 36.4435 17.1902 33.2035L16.3139 28.2552L21.2917 27.5605C24.5513 27.1064 27.1114 24.5439 27.5679 21.2843L28.2625 16.3065L33.2108 17.1828C36.4508 17.7572 39.6785 16.1126 41.1193 13.1549L43.3186 8.63616L47.7539 10.9999C50.6576 12.5487 54.2363 11.9817 56.519 9.6106L59.9995 6Z",
    fill: "url(#paint0_radial_184103_183578)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9994 18.2725C36.9538 18.2725 18.2725 36.9538 18.2725 59.9994C18.2725 83.0449 36.9538 101.726 59.9994 101.726C83.0449 101.726 101.726 83.0449 101.726 59.9994C101.726 36.9538 83.0449 18.2725 59.9994 18.2725Z",
    fill: "url(#paint1_linear_184103_183578)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_184103_183578",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.9995 59.9995) scale(53.9995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7237,
    stopColor: "#FFED54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#FFE649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8766,
    stopColor: "#FFD22D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_184103_183578",
    x1: 20.953,
    y1: 20.953,
    x2: 89.4446,
    y2: 89.4446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36001"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearSky);
export default __webpack_public_path__ + "static/media/clear-sky.3e1cfd01cb70f492ac28b8a34a9eef58.svg";
export { ForwardRef as ReactComponent };